import { render, staticRenderFns } from "./DormBoard.vue?vue&type=template&id=64b4d30b&scoped=true"
import script from "./DormBoard.vue?vue&type=script&lang=js"
export * from "./DormBoard.vue?vue&type=script&lang=js"
import style0 from "./DormBoard.vue?vue&type=style&index=0&id=64b4d30b&prod&scoped=true&lang=css"
import style1 from "./DormBoard.vue?vue&type=style&index=1&id=64b4d30b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4d30b",
  null
  
)

export default component.exports